import styled from 'styled-components'
import { DeviceTypes } from '../../../types/state'

export const PhoneVerificationWrapper = styled.div<{ device: DeviceTypes }>`
	justify-content: space-evenly;
	display: flex;
	flex-flow: column;
	/* height: var(--el-hg-md); */
	// background-color: var(--form-bg-color);
	margin-top: var(--mg-xs);
	// border-radius: var(--border-radius-lg);

	margin: 0 0.5em;

	width: ${({ device }) => (device === DeviceTypes.MOBILE ? '100%' : '30%')};
	margin-left: auto;
	margin-right: auto;
`
export const Heading = styled.div`
	font-size: 24px;
	color: white;
	/* margin-top: 15px; */
`
